import type { FaireProductEntity } from "../../entity_types/product";

export const p_yb3fru55e6: FaireProductEntity = {
  token: "p_yb3fru55e6",
  type: "product",
  name: "Honu / Hawaiian Green Sea Turtle Sticker",
  brandName: "Mahea Leah",
  imageUrl:
    "https://cdn.faire.com/fastly/74be91c47a1ac654989dd34a8e6b52d92a1dbab861835174cbcf9424e873df0d.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fba74658b931d55373f56525a2bdc543fbff718aad9613b2eface177f052517a.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
